//import RepoIcon from "../img/dash.png";

import Icon from "@mui/material/Icon";
import React from "react";

export function RepoIconImg(props) {
  var requestUrl = process.env.REACT_APP_API_BASE_URL + props.imageUri;

    return (
        <Icon sx={{ height:50, width:50 }}>
            <img alt={props.altText} src={requestUrl} height={50} width={50} />
        </Icon>
    );
}

export default RepoIconImg;